export const ACTION_PREFIX = 'UNIVERSITIES_PAGE';
export const STATE_NAME = 'universities';

export const Actions = {
  LOAD_START: `${ACTION_PREFIX}/LOAD_START`,
  LOAD_DONE: `${ACTION_PREFIX}/LOAD_DONE`,
  LOAD_FAIL: `${ACTION_PREFIX}/LOAD_FAIL`,
};
